import {PhotoSwipeLightbox, PhotoSwipeDynamicCaption, PhotoSwipe} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Gallery {
	static init() {

		if (!window.photoswipeloaded) {
			window.photoswipeloaded = true;
		}

		const arrowSVG = "<svg width=\"15\" height=\"10\" viewBox=\"0 0 15 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
			"<path d=\"M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z\" fill=\"#34847A\"/>\n" +
			"<path d=\"M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z\" fill=\"#34847A\"/>\n" +
			"</svg>";

		const options = {
			dataSource: [],
			showHideAnimationType: 'zoom',
			cropped: true,
			zoom: false,
			arrowPrevSVG: arrowSVG,
			arrowNextSVG: arrowSVG,
			paddingFn: (viewportSize) => {
				if(viewportSize.x < 768){
					return {
						top: 30, bottom: 30, left: 20, right: 20
					};
				}
				else{
					return {
						top: 30, bottom: 30, left: 70, right: 70
					};
				}
			},
			pswpModule: PhotoSwipe
		};

		let blocks = document.querySelectorAll('.block');
		blocks.forEach( (block) => {

			let images = block.querySelectorAll('.image-pswp');
			images.forEach((img) => {

				img.addEventListener('click', (e) => {

					e.preventDefault();
					let current = img;

					if (GlobalVariables.lightbox) {
						GlobalVariables.lightbox.destroy();
					}

					options.dataSource = [];

					images.forEach((image) => {
						options.dataSource.push({
							'src': image.dataset.pswpSrc,
							'width': image.dataset.pswpWidth,
							'height': image.dataset.pswpHeight,
							'cropped': true,
							'alt': image.dataset.pswpAlt
						});
					});

					GlobalVariables.lightbox = new PhotoSwipeLightbox(options);

					new PhotoSwipeDynamicCaption(GlobalVariables.lightbox, {
						type: 'below',
						captionContent: (slide) => {
							return slide.data.alt;
						}
					});

					GlobalVariables.lightbox.init();
					GlobalVariables.lightbox.loadAndOpen(Array.from(images).indexOf(current));
				});

			});

			let btn = block.querySelector('.btn-gallery-zoom');
			if( btn ){
				btn.addEventListener('click', () => {
					images[0].click();
				});
			}

		});

	}

}
